import { defineAnimationStyles, defineKeyframes } from '@chakra-ui/react';

/** Keyframes for the legacy tippy.js popover animations that stock has no equivalent for. */
export const keyframes = defineKeyframes({
  'perspective-in': {
    from: { opacity: 0, transform: 'perspective(700px) rotateX(-60deg) scale(0.88)' },
    to: { opacity: 1, transform: 'perspective(700px) rotateX(0) scale(1)' },
  },
  'perspective-out': {
    from: { opacity: 1, transform: 'perspective(700px) rotateX(0) scale(1)' },
    to: { opacity: 0, transform: 'perspective(700px) rotateX(-60deg) scale(0.88)' },
  },
});

/** Stock covers `scale-fade-*` (tippy `scale`) and `slide-fade-*` (tippy `shift-away`); these fill in the rest. */
export const animationStyles = defineAnimationStyles({
  'fade-in': { value: { animationName: 'fade-in' } },
  'fade-out': { value: { animationName: 'fade-out' } },
  'perspective-in': { value: { transformOrigin: 'var(--transform-origin)', animationName: 'perspective-in' } },
  'perspective-out': { value: { transformOrigin: 'var(--transform-origin)', animationName: 'perspective-out' } },
  // Mirror of stock `slide-fade-*`: content slides in toward the trigger instead of away from it.
  'shift-toward-in': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      '&[data-placement^=top]': { animationName: 'slide-from-top, fade-in' },
      '&[data-placement^=bottom]': { animationName: 'slide-from-bottom, fade-in' },
      '&[data-placement^=left]': { animationName: 'slide-from-left, fade-in' },
      '&[data-placement^=right]': { animationName: 'slide-from-right, fade-in' },
    },
  },
  'shift-toward-out': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      '&[data-placement^=top]': { animationName: 'slide-to-top, fade-out' },
      '&[data-placement^=bottom]': { animationName: 'slide-to-bottom, fade-out' },
      '&[data-placement^=left]': { animationName: 'slide-to-left, fade-out' },
      '&[data-placement^=right]': { animationName: 'slide-to-right, fade-out' },
    },
  },
});
